










































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import ListView from '@/components/helper/list-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import FileUpload from '@/components/controls/file-upload.vue';
import VImage from './image.vue';

class PageWorkshopInfoRequest extends PageRequest {
    manufacturers: Array<any> = null;
    function: number = null;
    customer: string = null;
    dealers: Array<any> = null;
    role: number = null;
}

@Component({
    components: { ListView, FormBase, FileUpload, VImage },
    watch: {
        dealers: function (val) {
            (this as any).pagerequest.dealers = null;
            if (val != null && (val.length > 1 || (val.length == 1 && val[0] != 0)))
                (this as any).pagerequest.dealers = val;
            (this as any).getpage();
        }
    }
})
export default class WorkshopInfos extends ListBase {
    entity: string = 'workshopinfo';
    pagerequest: PageWorkshopInfoRequest = new PageWorkshopInfoRequest();
    file: any = null;
    imageUrl: string = null;
    model: any = null;
    showImage: boolean = true;
    filterForm: boolean = true;

    filterItems = [
        this.gItem({ type: 'object', prop: 'function', label: 'Funcion Principal', generalType: 'FUNCTIONS', hideDetails: true, onchange: this.getpage, size: 3 }),
        this.gItem({ type: 'spacer', size: 9 }),
    ]

    items = [
        this.gItem({ type: 'text', prop: 'name', label: 'Nombre', size: 4, required: true }),
        this.gItem({ type: 'text', prop: 'location', label: 'Ubicacion', size: 2 }),
        this.gItem({ type: 'text', prop: 'code', label: 'Id', size: 2, required: true }),
        this.gItem({ type: 'text', prop: 'code2', label: 'Codigo', size: 2 }),
        this.gItem({ type: 'text', prop: 'document', label: 'RUC', size: 2, required: true }),
        this.gItem({ type: 'text', prop: 'business_name', label: 'Razon Social', size: 6, required: true }),
        this.gItem({ type: 'object', prop: 'zone_id', label: 'Zona', size: 3, required: true }),
        this.gItem({ type: 'object', prop: 'type_id', label: 'Tipo', size: 3, generalType: 'D_TYPES' }),
        this.gItem({ type: 'text', prop: 'address_sales', label: 'Direccion sala de ventas', icon: 'home', size: 6 }),
        this.gItem({ type: 'text', prop: 'address', label: 'Direccion taller de servicio', icon: 'home', size: 6 }),
        this.gItem({ type: 'ubigeo', prop: 'ubigeo', label: '', size: 6, entity: 'department', returnObject: true }),
        this.gItem({ type: 'phone', prop: 'phone1', label: 'Telefono central', size: 3 }),
        this.gItem({ type: 'phone', prop: 'phone2', label: 'Telefono de citas', size: 3 }),
    ]

    columns = [
        this.gCol('id', 'ID de Usuario', 'text'),
        this.gCol('full_name', 'Nombre y Apellido', 'text'),
        this.gColO({ type: 'text', value: 'function_id', text: 'Funcion principal', generalType: true }),
        this.gCol('phone', 'Telefono', 'text'),
        this.gCol('movil', 'Celular', 'text'),
        this.gCol('email', 'Direccion de Email', 'text'),
    ]

    get dealer() {
        return this.$store.state.app.dealer;
    }

    get dealers() {
        return this.$store.state.app.dealers;
    }

    get loading() {
        return this.$store.state.workshopinfo.loading;
    }

    get isDealer() {
        return Util.abp.session.isDealer();
    }

    get dealerModels() {
        let list = [];
        this.$store.state.dealer.activeList.forEach(d => {
            if (this.dealers.indexOf(d.id) >= 0)
                list.push(d);
        });
        return list;
    }

    openImage(item) {
        this.imageUrl = item.fileurl;
        this.showImage = !this.showImage;
    }
   

    async getpage() {
        let list: any = this.$refs.listView
        if (list != undefined) {
            await list.getpage();
        }
    }

    async importFile(data) {
        if (this.file == null) return;

        let formData = new FormData();
        formData.append('file', this.file);
        formData.append('filename', this.file.name);
        formData.append('dealer_id', data.entity_id);

        let result = await this.$store.dispatch({
            type: 'workshopinfo/saveImage',
            data: formData
        });            

        if (result) {
            this.$store.state.dealer.activeList.forEach(d => {
                if (d.id == result.id) {
                    d.filename = result.filename;
                    d.fileurl = result.fileurl;
                }                        
            });
        }
    }

    async deleteImage(id) {
        await this.$store.dispatch({
            type: 'workshopinfo/deleteImage',
            data: {id: id}
        });

        this.$store.state.dealer.activeList.forEach(d => {
            if (d.id == id) {
                d.filename = null;
                d.fileurl = null;
            }
        });
    }

    mounted() {
        if (this.$route.query.dealer) {
            this.pagerequest.dealers = [this.$route.query.dealer];
            Util.toRoute(this, 'workshopinfo');
        } 
    }

    created() {
        if (this.$route.query.dealer) {
            this.pagerequest.dealers = [this.$route.query.dealer];
            Util.toRoute(this, 'workshopinfo');
        } else {
            this.pagerequest.dealers = null;
            if (this.dealers != null && (this.dealers.length > 1 || (this.dealers.length == 1 && this.dealers[0] != 0)))
                this.pagerequest.dealers = this.dealers;
        }
    }
}